import React from 'react';

import ExplicitGroupValues from './explicit-group-values';
import {
  ExperimentAssignmentStrategy,
  getAssignmentStrategy,
} from '@/features/experiment/constants';
import { useExperimentContext } from '@/features/experiment/contexts/experiment-context';

const ExplicitGroup = () => {
  const experimentContext = useExperimentContext();
  const { configurations } = experimentContext;
  const experimentStrategy = getAssignmentStrategy(configurations);

  if (experimentStrategy !== ExperimentAssignmentStrategy.EXPLICIT_GROUP) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <ExplicitGroupValues />
    </div>
  );
};

export default ExplicitGroup;
